import { isArray, isEmpty, isFunction, isObject } from 'mc-ui-utils';
import constants from '../constants';
import PubSub from '../state/pubsub';
import { replaceMacroFromUrl } from './khazaddumbridge';
export const setUpWebpeekBridges = (iframe, glanceId, webpeekUrl, imageUrl) => {
    iframe.contentWindow.GlanceLive = window.GlanceLive;
    getWebpeekGlanceInterface(iframe.contentWindow, glanceId, imageUrl);
    iframe.contentWindow.PreferencesStore = window.PreferencesStore;
    iframe.contentWindow.AndroidUtils = window.AndroidUtils;
    iframe.contentWindow.sourceUrl = replaceMacroFromUrl(webpeekUrl, glanceId);
};
export const getWebpeekGlanceInterface = (webpeekWindow, glanceId, imageUrl) => {
    webpeekWindow.GlanceAndroidInterface = {};
    webpeekWindow.GlanceAndroidInterface.sendCustomAnalyticsEvent = (type, extras) => {
        window.Gondolin.sendCustomAnalyticsEvent(glanceId, type, extras);
    };
    webpeekWindow.GlanceAndroidInterface.hideNativeUiElement = (element) => {
        PubSub.publish("HIDE_UI_ELEMENT" /* HIDE_UI_ELEMENT */, { glanceId, element });
    };
    webpeekWindow.GlanceAndroidInterface.getGlanceBackgroundImageUri = () => imageUrl;
    webpeekWindow.GlanceAndroidInterface.showNativeUiElement = (element) => {
        PubSub.publish("SHOW_UI_ELEMENT" /* SHOW_UI_ELEMENT */, { glanceId, element });
    };
    webpeekWindow.GlanceAndroidInterface.moveToNextGlance = () => {
        PubSub.publish("MOVE_NEXT_GLANCE" /* MOVE_NEXT_GLANCE */, { glanceId });
    };
    webpeekWindow.GlanceAndroidInterface.moveToPrevGlance = () => {
        PubSub.publish("MOVE_PREV_GLANCE" /* MOVE_PREV_GLANCE */, { glanceId });
    };
    webpeekWindow.GlanceAndroidInterface.holdGlance = () => {
        PubSub.publish("HOLD_UI" /* HOLD_UI */, { glanceId });
    };
    webpeekWindow.GlanceAndroidInterface.unHoldGlance = () => {
        PubSub.publish("UNHOLD_UI" /* UNHOLD_UI */, { glanceId });
    };
    webpeekWindow.GlanceAndroidInterface.isHighlights = () => true;
    /*   const bridgeMethods = [
      'getNativeUiElements',
      'getBubbleTrayMode',
      'appInstallService',
      'canShowKeyBoard',
      'disableAutoPlay', // needs to be added
      'enableAutoPlay', // needs to be added
      'fireBeaconUrl',
      'followCreator',
      'getAllLanguages',
      'getAllSubscribedLanguages',
      'getBottomOverlayHeight',
      'getCategorySubscriptions',
      'getGlanceSdkVersion',
      'getLikeCount',
      'getLocale',
      'getLocation',
      'getRegion',
      'getShareCount',
      'getTopOverlayHeight',
      'getViewportHeight',
      'getViewportWidth',
      'hideCtaView',
      'installApp',
      'installAppAfterUnlock',
      'installApps',
      'installAppsAfterUnlock',
      'isAppInstalled',
      'isAutoPlayEnabled',
      'isAutoPlayFeatureEnabled',
      'isCategorySubscribed',
      'isFollowingCreator',
      'isLanguageSubscribed',
      'isOneClickInstallEnabled',
      'isSessionMuted',
      'launchApp',
      'launchAppAfterUnlock',
      'launchIntent',
      'launchIntentAfterUnlock',
      'likeGlance',
      'openCtaUrl',
      'requestPermission',
      'scheduleNotification',
      'selfUpdateAfterUnlock',
      'sendLocalBroadcast',
      'shareGlance',
      'shouldAutoOpenApp',
      'shouldInstallLater',
      'shouldRequestPermission',
      'subscribeLanguage',
      'unFollowCreator',
      'unlikeGlance',
      'unsubscribeLanguage',
      'updateCategorySubscriptions',
      'updateVolumeState',
      'userEngaged',
    ]; */
    const GlanceBridges = Object.keys(window.GlanceAndroidInterface);
    const NativeBridges = GlanceBridges.filter((key) => constants.GONDOLIN_BRIDGE.indexOf(key) < 0);
    NativeBridges.forEach((method) => {
        // @ts-expect-error since args can be never as well, TS will complain
        webpeekWindow.GlanceAndroidInterface[method] = (...args) => {
            // @ts-expect-error since args can be never as well, TS will complain
            return window.Gondolin[method](...args);
        };
    });
    /* webpeekWindow.GlanceAndroidInterface.getAllCategories =
      window.Gondolin.getAllCategories; */
};
export const setWebpeekBaseUrl = (path, webpeekHtml) => {
    const baseUrl = getBaseUrl(path);
    return webpeekHtml.replace('<head>', `<head><base href="${baseUrl}" />`);
};
export const convertToText = (obj) => {
    //create an array that will later be joined into a string.
    const string = [];
    //is object
    //    Both arrays and objects seem to return "object"
    //    when typeof(obj) is applied to them. So instead
    //    I am checking to see if they have the property
    //    join, which normal objects don't have but
    //    arrays do.
    if (isObject(obj) && !isArray(obj) && !isFunction(obj)) {
        string.push('{');
        for (const prop in obj) {
            string.push(prop, ': ', convertToText(obj[prop]), ',');
        }
        string.push('}');
        //is array
    }
    else if (isArray(obj)) {
        string.push('[');
        for (const prop in obj) {
            string.push(convertToText(obj[prop]), ',');
        }
        string.push(']');
        //is function
    }
    else if (isFunction(obj)) {
        string.push(obj.toString());
        //all other values can be done with JSON.stringify
    }
    else {
        string.push(JSON.stringify(obj));
    }
    return string.join('');
};
export const getBaseUrl = (url) => {
    if (!isEmpty(url)) {
        const path = url.split('?')[0];
        return path.replace('/index.html', '/');
    }
    return url;
};
//# sourceMappingURL=webpeekhelper.js.map